import { render, staticRenderFns } from "./AddProfileCard.vue?vue&type=template&id=6e8367af&"
import script from "./AddProfileCard.vue?vue&type=script&lang=js&"
export * from "./AddProfileCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports